// extracted by mini-css-extract-plugin
export default {"imageSection":"ImageSection_imageSection__1trD4","imageWrapper":"ImageSection_imageWrapper__Wkyjc","profileImage":"ImageSection_profileImage__Xpi00"};